module.exports = __webpack_public_path__ + "static/media/nav-close-icon.4c220281.svg";